import {css, view} from '@sail/ui/deprecated';
import {css as themeCss} from '@sail/theme-classic';
import {useUniversalHelpDotComDesign} from '../../FeatureFlagsProvider';
import {dotComColors, dotComTransitions} from '../../theme/dotCom';
import {useTheme} from '../../ThemeProvider';

type Props = {
  background: 'neutral100' | 'neutral600';
  borderTop?: string;
  children: React.ReactNode;
};

export const ChatBubble = ({
  background,
  borderTop,
  children,
}: Props): JSX.Element => {
  const useDotComDesign = useUniversalHelpDotComDesign();
  const theme = useTheme();
  const paddingX = useDotComDesign ? css.value('14px') : 'medium';

  const chatBubbleUses = useDotComDesign
    ? [
        themeCss.token.assign({
          color: {
            neutral100: dotComColors.brand700,
            neutral600: theme.linkColor,
          },
        }),
      ]
    : [];

  return (
    <view.div
      data-testid="chat-bubble"
      uses={chatBubbleUses}
      css={{
        borderRadius: 'medium',
        background: css.value(`$color.${background}`),
        paddingX,
        paddingY: 'small',
        whiteSpace: css.value('pre-line'),
        overflow: css.value('hidden'),
        borderTop: css.value(borderTop || ''),
        overflowWrap: css.value('break-word'),
        stack: 'y',
        gap: 'small',
        ...(useDotComDesign && {
          '& a': {
            transition: css.value(dotComTransitions.buttonTransition),
          },
          '& a:hover': {
            color: css.value(dotComColors.brand500),
          },
          '& a:focus-visible': {
            outline: theme.focusVisibleOutline,
          },
        }),
      }}
    >
      {children}
    </view.div>
  );
};
